import '../libs/slider'

import { createSchemaorgBreadcrumb } from '../function/structured-data'
createSchemaorgBreadcrumb()

import { headerScripts } from '../function/header'
headerScripts()

import { Accordion } from '../function/acordion_new'
Accordion({
  trigger: 'js-accordion'
})

import { sortUi } from '../function/sort-ui'
sortUi({
  trigger: 'js-sort'
})

import { modal } from '../function/modal'
modal({
  trigger: 'js-modal'
})

import { modalVisible } from '../function/modal-visible'
modalVisible({
  trigger: 'js-modal-visible'
})

import { scroll } from '../function/smoothscroll' 
scroll({
  targetClassName: '.js-scroll',
  buffer: 100,
})

import { tab } from '../function/tab'
tab({
  target: 'js-tab'
})

import { ClipBord } from '../function/clipbord'
ClipBord({
  trigger: 'js-clipboard'
})

import { countUp } from '../function/countup'
countUp({
  trigger: 'js-countup'
})

import { landingHash } from '../function/landing-hash'
landingHash()

import { slideToggle } from '../function/slide-toggle'
slideToggle({
  target: 'js-slide-toggle',
  duration: 600
})

